import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { Modal } from '@ui/components/Modal';
import { SlimArrowButton } from '@ui/components/SlimArrowButton';

import styles from './HeavyModalCard.module.css';

export type Props = {
  open?: boolean;
  header?: ReactNode;
  onBack?: () => void;
  preset?: 'gray' | 'black';
  children: ReactNode;
};
export function HeavyModalCard({ open, onBack, header, preset = 'gray', children }: Props) {
  return (
    <Modal className={styles.modal} open={open}>
      <div
        className={cx(styles.layoutContainer, {
          [styles.black]: preset === 'black',
          [styles.gray]: preset === 'gray',
        })}
      >
        <div className={styles.header}>
          <div className={styles.left}>
            {onBack && (
              <SlimArrowButton colorPreset="golden" direction="left" onClick={onBack} size="32" />
            )}
          </div>
          <div className={styles.center}>{header}</div>

          <div className={styles.right} />
        </div>

        <div className={styles.innerContainer}>{children}</div>
      </div>
    </Modal>
  );
}
